import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import SettlementItemBasicInfoComponent from "./settlement-item-basic-info.component";

export const SettlementItemPopup = ({ 
  selectedSettlementItem,
  // selectedParticipant,
  closeModal,
  handleSaveSettlementItem,
}: any) => {
  console.log('selectedSettlementItem', selectedSettlementItem)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedSettlementItem));

    const handleLocalFormChange = ({path, value}: any) => {
      console.log('selectedSettlementItem, path, value', selectedSettlementItem, path, value)
      const updatedData = updateNestedValue(selectedSettlementItem, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveSettlementItem(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementItemBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedSettlementItem={selectedSettlementItem}
            // selectedParticipant={selectedParticipant}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }